'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'knife-kitchen';
var width = 576;
var height = 512;
var aliases = [128298];
var unicode = 'f6f5';
var svgPathData = 'M481.1 6.9l88 80 6 5.4-5.5 5.9-105.1 112.9 0 66.1-4.8 2.1-56 24-5 2.1-3.8-3.8-104-104-5.7-5.7 5.7-5.7 179.2-179.2 5.4-5.4 5.6 5.1zM307.8 192l94.5 94.5 46.2-19.8 0-61.9 2.1-2.3 101.7-109.3-76.4-69.4-168.1 168.1zM11.8 468.5L243.7 231.1 255 242.4 25.8 477c2.7 1.4 5.8 2.8 9.2 4.3 17 7.2 42.9 14.7 77.4 14.7 111.3 0 182.7-47.6 255.4-118.2-15.3-15.3-25.9-25.9-31.9-31.9l11.3-11.3 43.3 43.3c-3.8 3.8-7.6 7.5-11.4 11.2-74.1 72-149.4 122.8-266.7 122.8-48.2 0-81.2-13.6-98.3-23.1-9.1-5-13.7-8.9-13.7-8.9l11.3-11.5zM416.5 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faKnifeKitchen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;